
import { Component, Vue, Prop, Emit } from "vue-property-decorator"

import RichTextEditor from "@/components/Fields/RichTextEditor.vue"
import { Field } from "@/types"
import { CaseColumn, caseColumns } from "@/types/caseColumns"

@Component({
	components: {
		"rich-text": RichTextEditor
	}
})
export default class RichTextTemplate extends Vue {
	@Prop({ required: true })
	public value!: string | null

	@Prop({ required: true })
	public fields!: CaseColumn[]

	@Prop({ default: () => [] })
	public additionalFields!: { id: string, label: string }[]

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ type: Boolean, default: true })
	public allowImages!: boolean

	public get placeholders (): { id: string, label: string }[] {
		return [
			...this.additionalFields,
			...caseColumns.map(c => {
				return { id: c.displayKey || c.key, label: c.label }
			}),
			...(this.fields
				? this.fields.filter(f => f.dynamicField).map(f => {
					return { id: f.key, label: f.label }
				})
				: [])
		]
	}
}
